import * as echarts from 'echarts';
import { Message } from 'element-ui';

export const convertBase64UrlToBlob = (base64) => {
  const parts = base64.dataURL.split(';base64,');
  const contentType = parts[0].split(':')[1];
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; i++) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], { type: contentType });
};

export const exportImg = (id, name) => {
  const myChart = echarts.getInstanceByDom(
    document.getElementById(id)
  );
  try {
    const url = myChart.getConnectedDataURL({
      pixelRatio: 1,
      backgroundColor: '#010a1e', // 图表背景色
      excludeComponents: [
        'toolbox', // 保存图表时忽略的工具组件,默认忽略工具栏
      ],
      type: 'png', // 图片类型支持png和jpeg
    });
    const a = document.createElement('a');
    a.download = `${name}.png`;
    a.target = '_blank';
    a.href = url;
    // Chrome and Firefox
    if (typeof MouseEvent === 'function') {
      const evt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      a.dispatchEvent(evt);
    } else {
      // IE
      const base64 = {
        dataURL: url,
        type: 'png',
        ext: 'png',
      };
      const blob = convertBase64UrlToBlob(base64);
      // 下载
      window.navigator.msSaveBlob(
        blob,
        `${name}.png`
      );
    }
  } catch (error) {
    Message({
      showClose: true,
      message: "下载失败，请稍后重试",
      type: "error",
    });
  }

};


// WEBPACK FOOTER //
// ./src/utils/downLoad.js